import * as React from 'react';
import { SVGProps } from 'react';

const IconRemoveFromComparisonSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 1h1v10H1V1zm10 2V2H6v1h5zM6 5H5v6h1V5zm2 2H7v4h1V7zm1 2h1v2H9V9zM4 3H3v8h1V3z" />
  </svg>
);
export default IconRemoveFromComparisonSizeXs;
